const domWrap = (element) => {
	if(!element) {
		element = document.createElement('div');
		element.empty = true;
	}
	element.store = element.store || {};
	element.on = (action,delegationOrFn, fn) => {
		if(typeof delegationOrFn === 'function') fn = delegationOrFn;
		let delegation = typeof delegationOrFn === 'string' ? delegationOrFn : false;
		if(!fn) return;
		element.addEventListener(action, function(event){
			for (let target = event.target; target && target!=this; target=target.parentNode) {
				// loop parent nodes from the target to the delegation node
				if (!delegation || target.matches(delegation)) {
					fn.call(target, event);
					break;
				}
			}
		}, false);
		return element;
	};
	element.setSelected = (className = 'selected') => {
		[...element.parentNode.childNodes].forEach(node => node.classList?.remove(className));
		element.classList?.add(className);
		return element;
	};
	element.trigger = event => {
		element.dispatchEvent(new Event(event,{bubbles:true}));
		return element;
	};
	element.css = styles => {
		Object.keys(styles).forEach(key => element.style[key] = styles[key]);
		return element;
	};
	element.wrapInner = (wrapper) => {
		element.appendChild(wrapper);
		while (element.firstChild !== wrapper) {
			wrapper.appendChild(element.firstChild);
	   	}
		return element;
	};
	element.data = (key, value) => {
		if(value) {
			element.store[key] = value;
			return element;
		}
		else {
			return element.store[key];
		}
	},
	element.offset = () => {
		const rect = element.getBoundingClientRect();
		return { 
			top: rect.top + window.scrollY, 
			left: rect.left + window.scrollX, 
		};
	},
	element.check = {
		get overflowLeft() {
			return overflowHorizontal(element) && element.scrollLeft > 0;
		},
		get overflowRight() {
			return overflowHorizontal(element) && element.scrollWidth - element.scrollLeft > element.offsetWidth;
		}
	};

	return element;
};

function overflowHorizontal(element){
	return element.scrollWidth - element.offsetWidth > 1;
}


export default domWrap;